// @flow

import { fromJS } from 'immutable';
import { loadOrder } from '../State/order';
import recalculateOrderItem from './recalculateOrderItem';
import type { OrderItem } from '../types';

export type UpdateOrderItemFieldParams = {
  orderGroupIndex: number,
  orderItemIndex: number,
  field: string,
  value: string|null
}

export default (params: UpdateOrderItemFieldParams) => (dispatch: Function, getState: Function) => {

  let order = fromJS(getState().screens.OrderView.order);

  // Get the previous value before updating
  const previousValue = order.getIn(
    ['order_groups', params.orderGroupIndex, 'order_items', params.orderItemIndex, params.field]
  );

  order = order.setIn(
    ['order_groups', params.orderGroupIndex, 'order_items', params.orderItemIndex, params.field],
    params.value
  )

  // Reset fields if type is being changed to null or 'TO' (Title Only)
  if (params.field === 'type' && (!params.value || params.value === 'TO') && previousValue && previousValue !== 'TO') {

    order = order.updateIn(
      ['order_groups', params.orderGroupIndex, 'order_items', params.orderItemIndex],
      (orderItem: OrderItem) => Object.assign({}, orderItem, {
        type: params.value, // Explicitly preserve the new type value
        flag: null,
        quantity: '0.00',
        unit: 'm2',
        rate: '0.00',
        subtotal: '0.00',
        discount: '0.00',
        total: '0.00'
      })
    )

  }

  order = order.toJS();

  dispatch(loadOrder(order));

  if (['rate', 'quantity', 'type'].includes(params.field)) {

    dispatch(recalculateOrderItem({
      orderGroupIndex: params.orderGroupIndex,
      orderItemIndex: params.orderItemIndex
    }))

  }

}
